import React from 'react';

interface DownloadStatusProps {
  isDownloading: boolean;
  reportType?: string;
}

const DownloadStatus: React.FC<DownloadStatusProps> = ({ isDownloading, reportType }) => {
  if (!isDownloading) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[9999]">
      <div className="flex items-center gap-3 rounded-lg border border-red-500/40 bg-[#1f1f1f] px-4 py-3 shadow-xl">
        <svg className="animate-spin h-5 w-5 text-red-500" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
        <div className="text-sm text-gray-200">
          <div className="font-semibold">Downloading report...</div>
          {reportType && <div className="text-xs text-gray-400">{reportType}</div>}
        </div>
      </div>
    </div>
  );
};

export default DownloadStatus;
